import {
  SET_TRAINER_DATA,
  SET_TRAINERS_DATA,
  SET_TRAINER_ATTRIBUTE,
  SET_TRAINER_COUNT,
  SET_TRAINER_DASHBOARD_WEEKLY_SCHEDULE,
  SET_TRAINER_CALENDAR_SCHEDULE,
  SET_ADD_PROGRAM_MODAL_OPEN,
} from '../types/types';

export const setTrainerData = (value) => {
  return {
    type: SET_TRAINER_DATA,
    payload: { data: value },
  };
};
export const setTrainerCount = (value) => {
  return {
    type: SET_TRAINER_COUNT,
    payload: { data: value },
  };
};
export const setTrainersData = (value) => {
  return {
    type: SET_TRAINERS_DATA,
    payload: { data: value },
  };
};

export const setAllTrainersData = (value) => {
  return {
    type: 'SET_ALL_TRAINERS_DATA',
    payload: { data: value },
  };
};

export const setTrainerAttribute = (value) => {
  return {
    type: SET_TRAINER_ATTRIBUTE,
    payload: { data: value },
  };
};
export const setTrainerDashboardSchedule = (value) => {
  return {
    type: SET_TRAINER_DASHBOARD_WEEKLY_SCHEDULE,
    payload: { data: value },
  };
};

export const setTrainerCalendarSchedule = (value) => {
  return {
    type: SET_TRAINER_CALENDAR_SCHEDULE,
    payload: { data: value },
  };
};
export const setAddProgramModalOpen = (value) => {
  return {
    type: SET_ADD_PROGRAM_MODAL_OPEN,
    payload: { data: value },
  };
};




// export const deleteTrainer = (id) => {
//   const api = "http://15.206.7.200:1320/trainer/" + id;
//   fetch(api,{method: "DELETE"})
//   .then(res=>res.json())
//   .then(res=>{//console.log(res)})
// }
// export const deleteMember = (id) => {
//   const api = "http://15.206.7.200:1320/member/" + id;
//   fetch(api,{method: "DELETE"})
//   .then(res=>res.json())
//   .then(res=>{//console.log(res)})
// }
